import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['destroyFlag'];

  remove() {
    this.destroyFlagTarget.value = true;
    this.element.style.display = 'none';
  }
}
